import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import BreadcrumbProgressItem from './breadcrumb-progress-item'

import styles from './breadcrumb-progress.css'

const BreadcrumbProgress = ({ items, step }) => (
  <ul styleName="list">
    {items.map((label, i) => (
      <BreadcrumbProgressItem
        active={i === step}
        complete={i < step}
        key={i}
        label={label}
      />
    ))}
  </ul>
)

BreadcrumbProgress.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  step: PropTypes.number.isRequired,
}


export default CSSModules(BreadcrumbProgress, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/breadcrumb-progress/breadcrumb-progress.js
 **/